import React from 'react';
import { useAuth } from '../../hooks/common/useAuth';
import { PERMISSION_SUBJECTS } from '../../constants/service/common/userPermissions';
import { PgProviderFeeWorkspace } from '../../views/pgProviderFee/components/PgProviderFeeWorkspace';

export const PgProviderFeeContainer = (): React.JSX.Element => {
  const { can } = useAuth();
  return <PgProviderFeeWorkspace canUpdate={can('update', PERMISSION_SUBJECTS.PAYMENT_PG_FEE)} />;
};
